// extracted by mini-css-extract-plugin
export default {"video":"Video_video__Lxu7l"};